// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.user-info {\n  display: flex;\n  align-items: center;\n  font-weight: 600;\n  font-size: 14px;\n  line-height: 21px;\n  color: #33352A;\n}\n.box_notification__title {\n  font-size: 17px;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
